<div class='modal-header'>
    <h4 class='modal-title'>
      {{ title | translate}}
    </h4>
</div>

<div class='modal-body'>
  <div  class="alert-missing-validated" *ngIf="errorMessage; else VALID">
    {{errorMessage}}
  </div>
  <ng-template #VALID>
    {{message | translate}}
  </ng-template>
</div>


<div class='modal-footer' *ngIf="errorMessage">

  <button type='button' class='btn btn-primary btn-sm'
          (click)='activeModal.close(false)'>
    {{ 'BUTTON.CLOSE' | translate }}
  </button>
</div>


<div class='modal-footer' *ngIf="!errorMessage">

  <button type='button' class='btn btn-primary btn-sm'
          (click)='confirm()'>
    {{ 'BUTTON.CONFIRM' | translate }}
  </button>

  <button ngbAutofocus type='button' class='btn btn-outline-secondary btn-sm'
          (click)='activeModal.close(false)'>
    {{ 'BUTTON.CANCEL' | translate }}
  </button>
</div>

